import { render, staticRenderFns } from "./OtherLoading.vue?vue&type=template&id=23bec69a&scoped=true&"
import script from "./OtherLoading.vue?vue&type=script&lang=js&"
export * from "./OtherLoading.vue?vue&type=script&lang=js&"
import style0 from "./OtherLoading.vue?vue&type=style&index=0&id=23bec69a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bec69a",
  null
  
)

export default component.exports